
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venda-direta/produtor-rural",
      function () {
        return require("private-next-pages/venda-direta/produtor-rural.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venda-direta/produtor-rural"])
      });
    }
  